import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "d-flex mb-2" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "fs-2" }
const _hoisted_4 = { class: "fs-5 fw-light" }
const _hoisted_5 = {
  key: 0,
  class: "form"
}
const _hoisted_6 = {
  key: 0,
  class: ""
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Spaces", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "add one or more spaces to this venue, which can be used when scheduling calls.", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = { class: "text-gray-800 text-hover-primary fw-bolder fs-6 cursor-pointer" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block" }, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "d-flex justify-content-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_ModalBase = _resolveComponent("ModalBase")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "Manage Venue",
    size: "modal-lg",
    ref: "modal",
    "is-loading": _ctx.isLoading,
    "loading-text": "Please Wait"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.description), 1)
        ]),
        (_ctx.mode !== 'add' && _ctx.spaceMode === 'off')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "btn-sm ms-auto",
              "is-loading": _ctx.isLoading,
              onClick: _ctx.removeVenue,
              type: "danger"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Remove ")
              ]),
              _: 1
            }, 8, ["is-loading", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.mode !== 'add' && _ctx.spaceMode === 'update')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "btn-sm ms-auto",
              "is-loading": _ctx.isLoading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeSpace(_ctx.space))),
              type: "danger"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Remove space ")
              ]),
              _: 1
            }, 8, ["is-loading"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.spaceMode === 'off')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_InputGroup, {
              label: "Name",
              "is-required": true
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.venue.name.$error}]),
                  placeholder: "Main Stage",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.venue.name) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.venue.name]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroup, {
              label: "Address",
              "is-required": true
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.venue.address.$error}]),
                  placeholder: "123 Broadway Ave.",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.venue.address) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.venue.address]
                ])
              ]),
              _: 1
            }),
            (_ctx.mode === 'update')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.venue.spaces, (space) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-12 col-md-3",
                        key: space.venueSpaceId
                      }, [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.toggleUpdateSpace(space)),
                          class: "d-flex align-items-center border border-dotted mb-8"
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["bullet bullet-vertical h-40px me-4", `bg-darkblue`])
                          }),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(space.name), 1),
                            _hoisted_13
                          ])
                        ], 8, _hoisted_10)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.spaceMode !== 'off')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_InputGroup, { label: "Space Name" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.space.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.space.name]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroup, { label: "Notes" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.space.notes) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.space.notes]
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
        (_ctx.spaceMode === 'off')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              onClick: _ctx.toggleClosed,
              type: "secondary",
              class: "btn-sm me-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.spaceMode === 'on')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              onClick: _ctx.toggleCancelSpace,
              type: "secondary",
              class: "btn-sm me-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.mode === 'update' && _ctx.spaceMode === 'off')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              onClick: _ctx.toggleAddSpace,
              type: "secondary",
              class: "me-4 btn-sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add New Space ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.mode === 'add')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 3,
              onClick: _ctx.addVenue,
              type: "primary",
              class: "btn-sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Next ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.mode === 'update' && _ctx.spaceMode === 'off')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 4,
              onClick: _ctx.updateVenue,
              type: "primary",
              class: "btn-sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save Changes ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.mode === 'update' && _ctx.spaceMode === 'add')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 5,
              onClick: _ctx.addSpace,
              type: "primary",
              class: "btn-sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add Space ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.mode === 'update' && _ctx.spaceMode === 'update')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 6,
              onClick: _ctx.updateSpace,
              type: "primary",
              class: "btn-sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Save Space ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.isLoading]
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}